import { 
  Box ,
} from "@mui/material";
import "../../common/css/dashboard.css";
import { isMobile } from 'react-device-detect';
import { IconBellRinging} from "@tabler/icons";
import { useState,  useEffect , } from "react";
import { useSelector } from "react-redux";
// import AxiosLoading from "../../../components/axios/AxiosLoading";
import AxiosCommon from "../../../components/axios/AxiosCommon";
import Badge from '@mui/material/Badge';

import ElectronicPaymentS from '../../community/ElectronicPaymentS';
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle"

const HeaderElectronicPayment = (props) => { 
  const axiosCommon = AxiosCommon(); 
  const reduxProfile = useSelector((state) => state.Profile.data);

  const [loading, setLoading] = useState(false);
  const [count, setCount] = useState(0)
  
  // const onClick = (e) => {
  //   if (typeof props.onClick === "function") {      
  //     if (color["name"] === "blue" ){
  //       color["name"]="green";
  //       message["myBusiness"]="금일 전체업무 현황입니다.";
  //       props.onClick({manager_cd:''});          
  //     }else{
  //       color["name"]="blue";
  //       message["myBusiness"]="금일 업무 현황입니다.";
  //       props.onClick({manager_cd:props.manager_cd});  
  //     }
  //   }
  // };
  
  const onClick = (e) => {
    if (isMobile){     
      alert('결재는 PC환경에서만 지원하고 있습니다.'); 
    }else{
      setElectronicPaymentS({
        open:true,
        electronic_cd:true,
        gridtheme:props.gridtheme,
      });
    }
  }

  const funcSearch = (async () => {
    // if (!validationFunc()) return;
    //초기화
    setCount(0);

    let paramRepo = {
      params: {
        company_cd: reduxProfile?.company_cd,
      },
    };

    if (loading) return;
    setLoading(true);
    try {
      await axiosCommon
        .get("/community/electronics/selectCount", paramRepo)
        .then((response) => {
          if (response.data?.code === 200) {
            setCount(response.data.data[0].count_cnt);
          }
        });
    } catch (error) {
      window.alert(error);
    } finally {
      setLoading(false);
    }
  });
  
  const [electronicPaymentS, setElectronicPaymentS] = useState({ 
    open: false,
    electronic_cd:false,
  });
  const funcsetElectronicClose = (item) => {
    setElectronicPaymentS({
      open: false,
      electronic_cd:false,
    })
    // if(item === 'save'){
      // funcSearch();
    // }
  }

  useEffect(() => {
    // 최초 한 번 실행
    funcSearch();
  
    // 30분마다 주기적으로 호출
    const interval = setInterval(() => {
      funcSearch();
    }, 60000); // 1분 = 60초 = 60000ms
    // }, 1200000); // 20분 = 20 * 60 * 1000 = 1800000 ms
    // }, 1800000); // 30분 = 30 * 60 * 1000 = 1800000 ms
  
    // 언마운트 시 인터벌 정리
    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  
  return (
  
    <Box 
      // onClick={onClick}
      // style={{ 
      //   display: 'flex', 
      //   justifyContent: 'flex-end',  
      // }}
    >      
      <Badge 
        badgeContent={count} color="primary" 
        onClick={(e) => onClick(e)}
        sx={{ cursor: 'pointer', display: 'inline-block' }}
      >
        <IconBellRinging style={{ color: count >= 1 ? 'red' : 'inherit'  }}    />
      </Badge>    

      <Dialog
        // fullScreen
        // keepMounted={true}
        sx={{
          "& .MuiDialog-container": {
            "& .MuiPaper-root": {
              width: "95%",
              height:"95%",
              // maxHeight:"90%",
              // maxWidth: "1000px",  
              maxWidth: "90%",  
              // maxHeight:"1000px",
              // paddingLeft:'10px',
              // paddingRight:'10px',
              overflowY:"auto",
            },
          }
        }}
        open={electronicPaymentS["open"]}
      >
        <DialogTitle />
        <ElectronicPaymentS
          gridtheme={props.gridtheme || "ag-theme-alpine"} 
          onClick={funcsetElectronicClose}  
          electronic_cd={electronicPaymentS["electronic_cd"]} 
          tabValue={1} 
        />
      </Dialog>   
    </Box> 
       
  );
};

export default HeaderElectronicPayment;
